import { CabinType } from 'models/types';
import FlightPassengersInterface from './flightPassengers.interface';

export default interface FlightFormInterface extends FlightPassengersInterface {
  kind: CabinType;
  departure: string;
  dateTime: string;
  destination: string;
  returnDateTime?: string;
  discountTicketId?: any;
}
export default interface DiscountFormInterface {
  kind: CabinType;
  departure: string;
  dateTime: string;
  destination: string;
  returnDateTime?: string;
  discountTicketId?: any;
}

export const checkInstanceOfFlightForm = (key: string) => {
  return [
    'kind',
    'departure',
    'dateTime',
    'destination',
    'returnDateTime',
    'discountTicketId',
    'adtCount',
    'chdCount',
    'infCount',
  ].includes(key);
};
